store.local = store.local || {};
store.local.onInit = store.local.onInit || function(){};
store.local.onUpdateAttribute = store.local.onUpdateAttribute || function(variant){};
store.local.onUpdateVariantData = store.local.onUpdateVariantData || function(variant){};
store.local.onSelectVariant = store.local.onSelectVariant || function(currentVariantKey){};
store.local.onInitProduct = store.local.onInitProduct || function(){};
store.local.onAddToCart = store.local.onAddToCart || function(){};
store.local.onCartIncrease = store.local.onCartIncrease || function(){};
store.local.onCartDecrease = store.local.onCartDecrease || function(){};
store.local.onCartBox = store.local.onCartBox || function(){};
store.local.onFilterUpdate = store.local.onFilterUpdate || function(){};
store.local.onCategoryProductsUpdate = store.local.onCategoryProductsUpdate || function(){};
store.local.prepareTermsDialogParams = store.local.prepareTermsDialogParams || function($dialog, $link){};
store.local.showMessage = false;
